import { render, staticRenderFns } from "./PopupAddLabel.vue?vue&type=template&id=8c555a70&scoped=true&"
import script from "./PopupAddLabel.vue?vue&type=script&lang=js&"
export * from "./PopupAddLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c555a70",
  null
  
)

export default component.exports